<script setup>
/**
 * Кнопка «добавить nedicom.ru в предпочтительные источники Google».
 *
 * ЗАЧЕМ. Выбранные читателем источники Google чаще показывает не только в блоке
 * новостей, но и в ИИ-режиме и ИИ-обзорах. Это тот же канал, по которому к нам
 * приходят из ИИ-ответов: клиентка по ДДУ нашла нас именно так.
 *
 * ⚠ СКРИПТ ГРУЗИМ ТОЛЬКО НА КЛИЕНТЕ И ТОЛЬКО ОДИН РАЗ. На сервере документа нет,
 * а Inertia рендерит страницу статьи и в SSR.
 *
 * ⚠ КНОПКА ПОЯВЛЯЕТСЯ НЕ ВЕЗДЕ. Функция раскатана не во всех странах и не для
 * всех аккаунтов: если Google ничего не отрисовал, прячем блок целиком, иначе на
 * странице останется висеть подпись без кнопки.
 */
import { ref, onMounted, onBeforeUnmount } from "vue";

const box = ref(null);
const shown = ref(false);
let timer = null;

const SCRIPT = "https://news.google.com/swg/js/v1/publisher.js";

onMounted(() => {
  if (!document.querySelector(`script[src="${SCRIPT}"]`)) {
    const s = document.createElement("script");
    s.async = true;
    s.src = SCRIPT;
    document.head.appendChild(s);
  }

  // Google дорисовывает кнопку внутрь нашего div асинхронно — ждём появления
  const check = () => {
    if (box.value && box.value.children.length > 0) {
      shown.value = true;
      return true;
    }
    return false;
  };

  let tries = 0;
  timer = setInterval(() => {
    if (check() || ++tries > 12) clearInterval(timer);
  }, 500);
});

onBeforeUnmount(() => timer && clearInterval(timer));
</script>

<template>
  <div class="mt-3 border-t border-gray-100 pt-3">
    <div ref="box" google-add-preferred-source-btn></div>
    <p v-show="shown" class="mt-1.5 mb-0 text-[11px] leading-snug text-gray-500">
      Google будет чаще показывать наши разборы в ответах на ваши вопросы
    </p>
  </div>
</template>
